import { render, staticRenderFns } from "./recommendContent.vue?vue&type=template&id=1e06bd27&scoped=true&"
import script from "./recommendContent.vue?vue&type=script&lang=js&"
export * from "./recommendContent.vue?vue&type=script&lang=js&"
import style0 from "./recommendContent.vue?vue&type=style&index=0&id=1e06bd27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e06bd27",
  null
  
)

export default component.exports